import type {
  AuthLoginResponse,
  AuthUsersResponse,
  SignalRNegotiateResponse,
} from '../../models/entities/auth-login.model';
import type { ApiEndpointDefinition } from '../api-endpoint.types';

export const AUTH_ENDPOINTS = {
  authLogin: {
    id: 'auth-login',
    method: 'POST',
    apiPath: '/api/auth/login',
    page: 'login',
    entity: 'auth-login',
  } satisfies ApiEndpointDefinition<AuthLoginResponse>,
  authUsers: {
    id: 'auth-users',
    method: 'GET',
    apiPath: '/api/auth/users',
    page: 'login',
    entity: 'auth-users',
  } satisfies ApiEndpointDefinition<AuthUsersResponse>,
  signalrNegotiate: {
    id: 'signalr-negotiate',
    method: 'GET',
    apiPath: '/api/resolve/connections/signalr-negotiate',
    page: 'login',
    entity: 'auth-signalr',
  } satisfies ApiEndpointDefinition<SignalRNegotiateResponse>,
} as const satisfies Record<string, ApiEndpointDefinition>;
